import InfoAboutDemoText from './InfoAboutDemoText';

export default InfoAboutDemoText;
